/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useEffect, useRef, useState } from 'react'
import classes from '@src/styles/LearnMore.module.css'
import classNames from 'classnames'

function LearnMore() {
  const [posts] = useState([])

  const subscribed = useRef(false)

  useEffect(() => {
    subscribed.current = true
    return () => {
      subscribed.current = false
    }
  }, [])

  const openResource = () => {
    // history.push(link);
  }

  const Resource = ({ resource }: { resource: any }) => (
    <div className={classes.resource} onClick={() => openResource()}>
      <div>
        <h2 className={classNames(classes.heading, classes.resourceCategory)}>How To</h2>
        <h2 className={classNames(classes.heading, classes.resourceTitle)}>How To</h2>
      </div>
      <img alt='' src={resource?.jetpack_featured_media_url ?? ''} className={classes.imgIcon} />
    </div>
  )

  return (
    <section className={classes.container}>
      <div className={classes.mainContent}>
        <div className={classes.textContainer}>
          <h2 className={classes.heading}>Learn More About Sustainable Waste Management</h2>
          <p className={classes.description}>
            Dive into our Sustainability Hub and discover resources covering best practice for
            disposing or recycling everything from cardboard to commercial food waste.
          </p>
        </div>
        <div className={classes.resourceContainer}>
          <p className={classNames(classes.heading, classes.listHeader)}>
            Sustainability Resource Hub
          </p>
          {posts.map((post: any) => (
            <Resource key={post.id} resource={post} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default LearnMore
